import axios from "axios";
import Api from "../api.js";

// Create an Axios instance with default configuration
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    "ngrok-skip-browser-warning": "1",
  },
});

// Define your service functions
const IssuesServices = {
  addNewIssueApi: (formData) => {
    return apiClient.post("/issues/new", formData);
  },

  addNewLetterApi: (formData) => {
    return apiClient.post("/letters/new", formData);
  },

  updateLetterApi: (id, data) => {
    return apiClient.post(`/letters/update/${id}`, data);
  },

  updateIssueApi: (id, data) => {
    return apiClient.post(`/issues/update/${id}`, data);
  },
  updateActivityApi: (id, data) => {
    return apiClient.post(`/issues/update_activity/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "1",
      },
    });
  },
  updateIssueFilesApi: (id, data) => {
    return apiClient.post(`/issues/update_files/${id}`, data);
  },

  getAllIssuesApi: (
    page,
    limit,
    status,
    search,
    startDate,
    endDate,
    projectId
  ) => {
    let url = `/issues/all?page=${page}&limit=${limit}&status=${status}&search=${search}&startDate=${startDate}&endDate=${endDate}&projectId=${projectId}`;

    // if (search) {
    //   url += `&search=${encodeURIComponent(search)}`;
    // }

    return Api.get(url);
  },
  getSingleIssue: (id) => {
    let url = `/issues/details/${id}`;
    return Api.get(url);
  },
  deleteFilesApi: (id, data) => {
    return apiClient.post(`/issues/delete_files/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  deleteLetterFilesApi: (id, data) => {
    return apiClient.post(`/letters/delete_files/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  deleteApi: (id) => {
    return apiClient.get(`/issues/delete/${id}`);
  },
  deleteLetterApi: (id) => {
    return apiClient.get(`/letters/delete/${id}`);
  },
};

export default IssuesServices;
